/**
 * Start impersonating a user. SuperAdmin only. The caller reloads the active user once it resolves.
 *
 * @param http The axios instance
 * @param userUuid The user to impersonate
 */
export function impersonate(http, userUuid) {
    console.info(`Impersonating to ${userUuid}`);
    return http.post('/api/sa/impersonate', {}, {
        headers: {
            'Impersonate-User': userUuid,
        },
    });
}
